module.exports = __webpack_public_path__ + "img/carpcu.d22a91ed.svg";